import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendNewClientWelcomeEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useSendNewClientWelcomeEmail = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(
        () => apiDispatch(sendNewClientWelcomeEmail({userId})),
        [userId, apiDispatch],
    );

    return useCommonEventHook({eventAction});
};
